import React, { useMemo, useState } from "react";

export default function PanicQuickReplies({ replies = [], activeIds = [] }) {
  const [open, setOpen] = useState(false);

  const visibleReplies = useMemo(() => {
    if (!activeIds.length) return replies;
    const selected = replies.filter((reply) => activeIds.includes(reply.id));
    return selected.length ? selected : replies;
  }, [replies, activeIds]);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Cosa dire</div>
          <div className="text-sm font-semibold text-slate-900">Risposte brevi, coerenti, verificabili.</div>
        </div>
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className="rounded-xl border px-3 py-2 text-sm font-semibold hover:bg-slate-50"
        >
          {open ? "Nascondi" : "Apri"}
        </button>
      </div>

      {open && (
        <div className="mt-4 space-y-3">
          {visibleReplies.map((reply) => (
            <div key={reply.id} className="rounded-xl border border-slate-200 bg-slate-50 p-3">
              <div className="text-xs font-semibold text-slate-500">{reply.question}</div>
              <div className="mt-1 text-sm font-medium text-slate-900">{reply.answer}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
